import React from 'react';
import './Paragraph.scss';

export interface Props {
  ParaClass?: any;
  ParaId?: any;
  children?: any;
  ParaStyle?: any;

}

export const Para = ({
  ParaClass,
  ParaId ,
  children,
  ParaStyle
}:Props) => {
  return (
    <p style={ParaStyle && ParaStyle} className={ParaClass} id={ParaId}>{ children }</p>
  )
}

export default Para;
